<script lang="ts">
    export let alphabet: string[];
    export let outputs: string[];

    export let selectedChar: string;
    export let selectedOutput: string;

    export let onCharChange = (char: string) => {};
    export let onOutputChange = (output: string) => {};
    export let onDeleteClick = () => {};
    import IconDelete from '../icons/Delete.svelte';


    function handleCharChange(event) {
        onCharChange(event.target.value);
    }

    function handleOutputChange(event) {
        onOutputChange(event.target.value); 
    }

    function handleDeleteClick() {
        onDeleteClick();
    }
</script>


<div style="grid-column: 1 / span 1; grid-row: auto">
    <select style="width: 10em;" value={selectedChar} on:change={handleCharChange}>
        {#each alphabet as char}
            <option value={char}>{char}</option>
        {/each}
    </select>
</div>

<div style="grid-column: 2 / span 1; grid-row: auto;">
    <select style="width: 10em;" value={selectedOutput} on:change={handleOutputChange}>
        {#each outputs as outputChar}
        <option value={outputChar}>{outputChar}</option>
        {/each}
    </select>
</div>

<div style="grid-column: 3 / span 1; grid-row: auto">
    <button 
        class="automaten-simulator-iconButton"
        on:click={handleDeleteClick}
    >
        <IconDelete />
    </button>
</div>